// Single source of truth for payment/fee status styling — previously redefined with
// drifting shade families across Students.jsx, StudentFinanceTab.jsx, Payments.jsx,
// StudentDashboard.jsx and DemoView.jsx. student/FeePayment.jsx intentionally stays on
// its own local pastel palette (predates this token system) and is not wired to this.
//
// 'paid' is kept as an alias of 'completed' — Students.jsx's monthly-summary badge uses
// the shorter key, but means the same status.
export const FEE_STATUS_BADGE = {
  completed:       'bg-green-100 text-green-700',
  paid:            'bg-green-100 text-green-700',
  pending:         'bg-amber-500/15 text-amber-400 border border-amber-500/20',
  overdue:         'bg-red-100 text-red-600',
  failed:          'bg-red-100 text-red-600',
  proof_submitted: 'bg-amber-500/15 text-amber-400 border border-amber-500/20',
  waived:          'bg-nav-hover text-muted',
  partial:         'bg-nav-hover text-secondary',
  no_record:       'bg-nav-hover text-subtle',
};

export const FEE_STATUS_LABEL = {
  completed:       'Paid',
  paid:            'Paid',
  pending:         'Pending',
  overdue:         'Overdue',
  failed:          'Failed',
  proof_submitted: 'Proof Submitted',
  waived:          'Waived',
  partial:         'Partially Paid',
  no_record:       'No record',
};
